<template>
	<v-container grid-list-xl>		
		<v-layout row wrap>			
			<v-flex lg6>
				<label class="blackLabel">Date From</label>
				<date-picker style="width: 100% !important" v-model="objProductSalesFilters.startDate" lang="en"></date-picker>
			</v-flex>
			<v-flex lg6>
				<label class="blackLabel">Date To</label>
				<date-picker style="width: 100% !important" v-model="objProductSalesFilters.endDate" lang="en"></date-picker>
			</v-flex>		
			<v-flex lg6>
				<label class="blackLabel">Quote Status</label>
				<v-select :items="psStatusses" v-model="objProductSalesFilters.quoteStatus" item-value="id" autocomplete label="Select Quote Status" single-line solo></v-select>
			</v-flex>
			<v-flex lg6>
				<label class="blackLabel">Quote Tender Status</label>
				<v-select :items="psTenderStatusses" v-model="objProductSalesFilters.quoteTenderStatus" item-value="id" autocomplete label="Select Quote Tender Status" single-line solo></v-select>
			</v-flex>
          <v-flex lg6>
            <label class="blackLabel">Product Tender Status</label>
            <v-select :items="psProductTenderStatusses" v-model="objProductSalesFilters.productTenderStatus" item-value="id" autocomplete label="Select Product Tender Status" single-line solo></v-select>
          </v-flex>
			<v-flex lg6>
				<label class="blackLabel">Originator</label>
				<v-select :items="psOriginators" v-model="objProductSalesFilters.originator" item-value="id" autocomplete label="Select Originator" single-line solo></v-select>
			</v-flex>			
			<v-flex lg6>
				<label class="blackLabel">Customer</label>
				<v-select :items="psCustomers" v-model="objProductSalesFilters.customer" item-value="id" autocomplete label="Select Customer" single-line solo></v-select>
			</v-flex>			
			<div class="pl-4 pr-1 pb-4 buttonHolder">
				<div style="float: right">
					<v-btn class="text-xs-right cancelButton" @click.stop="fncHideModal">Close</v-btn>					
					<v-btn color="success" class="text-xs-right" @click.stop="fncClearFilters()">Clear Filters</v-btn>
                    <v-btn color="success" class="text-xs-right" @click.stop="fncGenerateReport()">Generate Report</v-btn>
				</div>	
			</div>
			<v-flex lg12 class="requiredMessage">
				&nbsp;
			</v-flex>			
		</v-layout>
	</v-container>
</template>

<script>
	import { mapGetters } from 'vuex'; 	
	import DatePicker from 'vue2-datepicker'
	export default {
	  name: 'Settings',
	  data () {
			return {			
			};
		},		
		methods: {
			fncHideModal () {
				this.$store.commit('hideModal');
			},
            fncGenerateReport() {	
                this.$store.commit('fncEmptyProductSalesList');
                this.$store.dispatch({
                  type: 'fncPopulateProductSalesList',
                  objFilters: this.objProductSalesFilters,
                  refresh: true
                })
				this.$store.commit('hideModal');				
			},
            fncCheck(check) {
		      console.log(check);        
            },
            fncClearFilters() {
              this.objProductSalesFilters.startDate = '';
              this.objProductSalesFilters.endDate = '';
              this.objProductSalesFilters.quoteStatus = '';
              this.objProductSalesFilters.quoteTenderStatus = '';
              this.objProductSalesFilters.productTenderStatus = '';
              this.objProductSalesFilters.originator = '';
              this.objProductSalesFilters.customer = '';
            }
		},
		computed: {
			...mapGetters([			
				'objAuthorize',				
				'globalModalParams',
				'objSalesFilters',				
				'objProductSalesFilters',
				'psStatusses',
                'psTenderStatusses',
                'psProductTenderStatusses',
				'psOriginators',
				'psCustomers'
			])
		},
		components: {			
			DatePicker
		}
	}
</script>

<style scoped>
	/*@import '../../assets/css/shared.css'*/
</style>